import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getProductPriceInfo } from '../utils/price'
import CurrencySymbol from './CurrencySymbol'
import math, { formatNumber } from '../utils/math'

const StyledPrice = styled.div`
  color: #777;
  text-decoration: line-through;
  font-size: 12px;
`

const ProductOriPrice = memo(({ item, withQuantity = false }) => {
    const { oriAmount, amount } = getProductPriceInfo(item)

    if (!(oriAmount > amount)) {
        return null
    }

    const qty = withQuantity ? (item.quantity || 1) : 1

    return (
        <StyledPrice>
            <CurrencySymbol currency={item.currency || item.currencyCode} />
            {formatNumber(math.mul(oriAmount, qty))}
        </StyledPrice>
    )
})

ProductOriPrice.propTypes = {
    item: PropTypes.shape({
        currency: PropTypes.string,
        currencyCode: PropTypes.string,
        // 至少需要其中一个属性
    }).isRequired
}

ProductOriPrice.displayName = 'ProductOriPrice'

export default ProductOriPrice
